(function (angular) {
    'use strict';

    angular.module('channels')

        /**
         *
         */
        .factory('customChannelConfigService',
            ['$uibModal',
                function ($uibModal) {


                    var fac = {
                        getCustomConfig: getCustomConfig,
                        getChannelId: getChannelId
                    };

                    return fac;

                    function getChannelId(channelId) {
                        return $uibModal.open({
                            templateUrl: 'components/channels/customChannels/templates/customChannelId.html',
                            size: 'sm',
                            backdrop: 'static',
                            resolve: {
                                channelId: function () {
                                    return channelId;
                                }

                            },
                            controller: 'CustomChannelIdCtrl'
                        });
                    }
                    function getCustomConfig(channelId) {
                        return $uibModal.open({
                            templateUrl: 'components/channels/customChannels/templates/customChannels.html',
                            size: 'lg',
                            backdrop: 'static',
                            resolve: {
                                profileSchema: ['$q', 'profilesService', '$stateParams', 'profileHelper', function ($q, profilesService, $stateParams, profileHelper) {
                                    if (profileHelper.getSchema().length) {
                                        return profileHelper.getSchema();
                                    }
                                    else {
                                        return profilesService.getProfileSchema($stateParams.pickedApiSpaceId)
                                            .then(function (result) {
                                                return profileHelper.setSchema(result);
                                            }).catch(function (result) {
                                                var deferred = $q.defer();
                                                if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                                return deferred.promise;
                                            });
                                    }
                                }],
                                customChannelsData: ['$q', '$stateParams', 'customChannelService', function ($q, $stateParams, customChannelService) {
                                    return customChannelService.getCustomChannels($stateParams.pickedApiSpaceId)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }],
                                channelId: function () {
                                    return channelId;
                                }

                            },
                            controller: 'CustomChannelsCtrl',
                            controllerAs: 'vm'
                        });
                    }
                   

                }]);

})(window.angular);